import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"
import sha256 from "crypto-js/sha256"

export default class extends Controller {
  static classes = ["hidden"]
  static targets = ["button", "customBidForm", "messageContainer", "choiceLotSelectorModal", "reservePriceOffer"]

  static values = {
    currentBidAmountCents: Number,
    currentBidDigest: String,
    currentBidSlug: String,
    genericMessage: Object,
    isAuctionWebcast: Boolean,
    highestBidderMessageBody: String
  }

  connect() {
    this.dispatch("connect", { detail: { currentBidAndBidButton: this } })
  }

  disconnect() {
    if (this.modal) {
      this.modal.hide()
    }
  }

  displayElements(userSlug, isUserApproved, previewBidButton, showMessage) {
    const isUserCurrentBidder = userSlug !== "" && sha256(this.currentBidSlugValue + userSlug).toString() === this.currentBidDigestValue

    const isUserApprovedOrPreviewBidButton = isUserApproved || previewBidButton
    const message = this.#message(isUserCurrentBidder, isUserApprovedOrPreviewBidButton)

    if (showMessage) {
      this.#displayMessage(message)
    }

    this.#displayButton(isUserApprovedOrPreviewBidButton)
    this.#displayCustomBidForm(isUserApprovedOrPreviewBidButton)
    this.#disableButton(isUserCurrentBidder, previewBidButton)
    this.#showChoiceSelectorModal(isUserCurrentBidder)
    this.#displayReservePriceOffer(isUserCurrentBidder)
  }

  #displayMessage(message) {
    if (Object.keys(message).length > 0) {
      this.messageContainerTarget.classList.add(`alert-${message.type}`)
      this.messageContainerTarget.textContent = message.body
      this.messageContainerTarget.classList.remove(this.hiddenClass)
    }
  }

  #message(isUserCurrentBidder, isUserApprovedOrPreviewBidButton) {
    if (isUserCurrentBidder) {
      return { type: "success", body: this.highestBidderMessageBodyValue }
    }

    const messageForAllUsers = this.genericMessageValue.all
    if (messageForAllUsers) {
      return messageForAllUsers
    }

    const userType = isUserApprovedOrPreviewBidButton ? "approved" : "unapproved"

    return this.genericMessageValue[userType]
  }

  #displayButton(isUserApprovedOrPreviewBidButton) {
    if (this.hasButtonTarget && isUserApprovedOrPreviewBidButton) {
      this.buttonTarget.classList.remove(this.hiddenClass)
    }
  }

  #displayCustomBidForm(isUserApprovedOrPreviewBidButton) {
    if (this.hasCustomBidFormTarget && isUserApprovedOrPreviewBidButton) {
      this.customBidFormTarget.classList.remove(this.hiddenClass)
    }
  }

  #disableButton(isUserCurrentBidder, previewBidButton) {
    if (this.hasButtonTarget && ((isUserCurrentBidder && this.isAuctionWebcastValue) || previewBidButton)) {
      this.buttonTarget.disabled = true
    }
  }

  #displayReservePriceOffer(isUserCurrentBidder) {
    if (isUserCurrentBidder && this.hasReservePriceOfferTarget) {
      this.reservePriceOfferTarget.classList.remove(this.hiddenClass)
    }
  }

  #showChoiceSelectorModal(isUserCurrentBidder) {
    if (isUserCurrentBidder && this.hasChoiceLotSelectorModalTarget) {
      this.modal = new Modal(this.choiceLotSelectorModalTarget)
      this.modal.show()
    }
  }
}
